import { defineComponent as _defineComponent } from 'vue'
import { onMounted, ref } from "vue";
import { useSubCompaniesStore } from "@/pinia/subcompanies/subcompanies";
import SubCompaniesListTable from "@/components/company/SubCompaniesListTable.vue";
import ActionButton from "@/components/lib/button/ActionButton.vue";
import CreateSubCompanyFormModal from "@/components/company/forms/CreateSubCompanyFormModal.vue";
import SubCompaniesListTableFilter from "@/components/company/SubCompaniesListTableFilter.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'SubCompaniesList',
  setup(__props) {

onMounted(() => {
  useSubCompaniesStore().fetchSubCompanies();
});

const createCompanyModalShow = ref(false);

function handleShowCreateCompanyClick() {
  createCompanyModalShow.value = true;
}

return { __sfc: true,createCompanyModalShow, handleShowCreateCompanyClick, SubCompaniesListTable, ActionButton, CreateSubCompanyFormModal, SubCompaniesListTableFilter }
}

})